import React, { useContext, useState, useEffect } from 'react';
import { Typography, TextField, Stack, Autocomplete, Box } from '@mui/material';
import { CinchDialog } from '@cinch/ui';
import { UserStateContext } from 'context/user-state-context';
export const CompanySelector = ({
  open,
  onClose,
  onSubmit,
  title,
  permission
}) => {
  const {
    user,
    asCompany
  } = useContext(UserStateContext);
  const [availableCompanies, setAvailableCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [inputValue, setInputValue] = useState('');
  useEffect(() => {
    if (!user?.permissions) return;
    setAvailableCompanies(user.companies.sort((a, b) => a.name > b.name ? 1 : -1).filter(function (c) {
      const found = user.permissions['*'] || user.permissions[permission] === '*' || user.permissions?.[permission]?.indexOf(c.id) > -1;
      return found;
    }));
  }, [user, permission]);

  // Set default selected company to asCompany when dialog opens
  useEffect(() => {
    if (open && asCompany && availableCompanies.length > 0) {
      const defaultCompany = availableCompanies.find(c => c.id === asCompany.id);
      if (defaultCompany) {
        setSelectedCompany(defaultCompany);
      }
    }
  }, [open, asCompany, availableCompanies]);
  return <CinchDialog open={open} onClose={onClose} title={title} actionSize="large" customWidth={{
    xs: 'calc(100vw - 24px)',
    sm: '460px'
  }} customHeight="auto" onSubmit={() => onSubmit(selectedCompany)} submitText="Select" submitDisabled={!selectedCompany} bodyData={<Stack direction="column" spacing={2}>
          <Typography sx={{
      mb: 1,
      fontSize: '14px'
    }}>
            Select the appropriate company.
          </Typography>
          <Autocomplete value={selectedCompany} onChange={(event, newValue) => {
      setSelectedCompany(newValue);
    }} inputValue={inputValue} onInputChange={(event, newInputValue) => {
      setInputValue(newInputValue);
    }} options={availableCompanies} getOptionLabel={option => option?.name || ''} isOptionEqualToValue={(option, value) => option?.id === value?.id} renderInput={params => <TextField {...params} placeholder="Search for a company..." variant="outlined" size="small" />} renderOption={(props, option) => <Box component="li" {...props}>
                <Typography>{option.name}</Typography>
              </Box>} sx={{
      width: '100%'
    }} noOptionsText="No companies found" />
        </Stack>} />;
};